import { AnyAction } from "redux";
import { ReportedProductState } from "../types/reportedProductsType";
import {
  FETCH_REPORTED_PRODUCTS_FAILURE,
  FETCH_REPORTED_PRODUCTS_REQUEST,
  FETCH_REPORTED_PRODUCTS_RESET,
  FETCH_REPORTED_PRODUCTS_SUCCESS,
} from "../actions/reportedProductsAction";

const initialState: ReportedProductState = {
  reportedProductsData: {
    //products: [],
    reportedProducts: [],
    totalRecords: 0,
    success: false,
  },
  loading: false,
  error: null,
};

const ReportedProductsReducer = (
  state = initialState,
  action: AnyAction
): ReportedProductState => {
  switch (action.type) {
    case FETCH_REPORTED_PRODUCTS_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_REPORTED_PRODUCTS_SUCCESS:
      return {
        ...state,
        reportedProductsData: action.payload,
        loading: false,
        error: null,
      };
    case FETCH_REPORTED_PRODUCTS_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case FETCH_REPORTED_PRODUCTS_RESET:
      return {
        ...state,
        reportedProductsData: {
          //products: [],
          reportedProducts: [],
          totalRecords: 0,
          success: false,
        },
        loading: false,
        error: null,
      };
    // Handle other item-related actions here...
    default:
      return state;
  }
};

export default ReportedProductsReducer;
